import { Subscription } from 'rxjs';
import { Component, DoCheck, OnInit, OnDestroy } from '@angular/core';
import { environment } from 'src/environments/environment';
import { AuthService } from './shared/auth/auth.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent implements OnInit, OnDestroy, DoCheck {
  public subscriptions: Subscription[] = [];
  public userIsAuthenticated = false;
  public currentYear: number;
  public currentVersion: string;

  constructor(private authService: AuthService) {
    this.currentYear = new Date().getUTCFullYear();
    this.currentVersion = environment.version;
    this.subscriptions.push(
      this.authService.getAuthStatusListener().subscribe((result) => {
        this.userIsAuthenticated = result;
      })
    );
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach((s) => s.unsubscribe());
  }

  ngOnInit(): void {
    this.subscriptions = [];
    this.authService.autoAuthUser();
  }

  ngDoCheck(): void {
    // this.userIsAuthenticated = this.authService.getIsAuth();
  }
}
